import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'notification-settings',
    pluginName: 'SETTINGS',
    entityName: 'NOTIFICATION_SETTINGS',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
    fetchSuccessUseBackendMessage: false,
    fetchFailedUseBackendMessage: false,
    createSuccessUseBackendMessage: true,
    createFailedUseBackendMessage: true,
    deleteSuccessUseBackendMessage: false,
    deleteFailedUseBackendMessage: false,
    loadSuccessUseBackendMessage: false,
    loadFailedUseBackendMessage: false,
    editSuccessUseBackendMessage: false,
    editFailedUseBackendMessage: false,
    bulkDeleteSuccessUseBackendMessage: false,
    bulkDeleteFailedUseBackendMessage: false
});

// Fetch notificationSetting action creators

export const fetchNotificationSettingInit = () => {
    return crudActions.fetchInit();
};
export const fetchNotificationSettingStart = () => {
    return crudActions.fetchStart();
};
export const fetchNotificationSettingSuccess = (fetchNotificationSettingCount, listNotificationSettingCount) => {
    return crudActions.fetchSuccess(fetchNotificationSettingCount, listNotificationSettingCount);
};
export const fetchNotificationSettingFail = () => {
    return crudActions.fetchFail();
};


export const fetchNotificationSettingCount = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchNotificationSettingStart());
        try {
            let countRes = await rest.post("notification-settings/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchNotificationSettingSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchNotificationSettingFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch notification settings."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchNotificationSettingFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch notification settings."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}
export const fetchNotificationSetting = filterData => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchNotificationSettingStart());
        try {
            let listRes = await rest.post("notification-settings/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchNotificationSettingSuccess(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchNotificationSettingFail());
            return []

        } catch (error) {
            dispatch(fetchNotificationSettingFail());
            return []
        }
    }
}

export const loadNotificationSettingInit = () => {
    return crudActions.loadInit();
};
export const loadNotificationSettingStart = () => {
    return crudActions.loadStart();
};
export const loadNotificationSettingSuccess = loadedNotificationSetting => {
    return crudActions.loadSuccess(loadedNotificationSetting);
};
export const loadNotificationSettingFail = error => {
    return crudActions.loadFail(error);
};
export const loadNotificationSetting = id => {
    return async dispatch => {
        await crudActions.load(dispatch, id);
    };
};


// Create notification setting action creators
export const createNotificationSettingInit = () => {
    return crudActions.createInit();
};
export const createNotificationSettingStart = () => {
    return crudActions.createStart();
};
export const createNotificationSettingSuccess = createdNotificationSetting => {
    return crudActions.createSuccess(createdNotificationSetting);
};
export const createNotificationSettingFail = error => {
    return crudActions.createFail(error);
};

export const createNotificationSetting = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(createNotificationSettingStart());
        try {
            let res = await rest.post('/notification-settings/create', params);
            if (res.data && res.data.succeeded) {
                dispatch(createNotificationSettingSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully created notification setting.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(createNotificationSettingFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create notification setting."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create notification setting."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(createNotificationSettingFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
};

// Edit notification setting action creators
export const editNotificationSettingInit = () => {
    return crudActions.editInit();
};
export const editNotificationSettingStart = () => {
    return crudActions.editStart();
};
export const editNotificationSettingSuccess = editedNotificationSetting => {
    return crudActions.editSuccess(editedNotificationSetting);
};
export const editNotificationSettingFail = error => {
    return crudActions.editFail(error);
};

export const editNotificationSetting = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(editNotificationSettingStart());
        try {
            let res = await rest.post('/notification-settings/save', params);
            if (res.data && res.data.succeeded) {
                dispatch(editNotificationSettingSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully updated notification setting.`,
                    options: {
                        variant: 'success'
                    }
                });
                return res.data.result.data;
            }
            dispatch(editNotificationSettingFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot edit notification setting."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create notification setting."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(editNotificationSettingFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

export const bulkDeleteNotificationSettings = notificationSettingIDs => {
    return async dispatch => {
        await crudActions.bulkDelete(dispatch, notificationSettingIDs);
    };
};

export const deleteNotificationSetting = deleteData => {
    return async dispatch => {
        await crudActions.delete(dispatch, deleteData);
    };
};
